export var ECollaboratorInviteStatus;
(function (ECollaboratorInviteStatus) {
    ECollaboratorInviteStatus["pending"] = "pending";
    ECollaboratorInviteStatus["accepted"] = "accepted";
})(ECollaboratorInviteStatus || (ECollaboratorInviteStatus = {}));
//# sourceMappingURL=collaboratorInvite.js.map